










import { computed, defineComponent, toRefs } from '@vue/composition-api';
import { i18n } from './../../../../i18n';
const name = 'ttam-creative-auth-shop-alert';

export default defineComponent({
  name,
  components: {},
  props: {
    isStandardAdsWithShop: {
      type: Boolean,
      required: false,
    },
    isProductFromCatalog: {
      type: Boolean,
      required: false,
    },
    isStandardAdsWithShowcase: {
      type: Boolean,
      required: false,
    },
  },
  setup(props) {
    const { isStandardAdsWithShop, isProductFromCatalog, isStandardAdsWithShowcase } = toRefs(props);
    const desc = computed(() => {
      if (isStandardAdsWithShop.value) {
        return i18n.t('module_ad_no_shop_permission_edit_banner_text');
      } else if (isProductFromCatalog.value) {
        return i18n.t('module_ad_no_catalog_permission_edit_banner_text');
      } else if (isStandardAdsWithShowcase.value) {
        return i18n.t('module_ad_no_showcase_permission_edit_banner_text');
      }
      return '';
    });
    return {
      desc,
      name,
    };
  },
});
